// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Header_toolbar__2A6iG","logo":"Header_logo__1s0ma"};